export default __webpack_public_path__ + "static/media/participant.3c7ae536.svg";